/** @format */

import React, { Component } from 'react'

import './style.scss'

export default class ListItemInfoPharmacies extends Component {
	render() {
		return (
			<>
				<div className='ph-order-detail-pharmacies-list-container'>
					<h3 className='ph-order-detail-pharmacies-list-title'>{this.props.title}</h3>
					<h3
						className={`ph-order-detail-pharmacies-list-description ${this.props.classDescription}`}>
						{this.props.description ? <>{this.props.description}</> : 'Dato no encontrado'}
					</h3>
				</div>
			</>
		)
	}
}
